import { useEffect, useState } from 'react';
import api from '../../../utils/api';

const RETRY_AFTER_MS = 1500;

/**
 * The student's school's offered programs, with how the load went: 'loading', 'ok' or 'failed'.
 * A list handed in (the chat already loaded it) is used as is; otherwise it's loaded here, with one
 * more try after a short wait. 'failed' means "couldn't check", never "not offered".
 */
export const useSchoolOfferings = (given) => {
  const hasGiven = Array.isArray(given) && given.length > 0;
  const [list, setList] = useState([]);
  const [state, setState] = useState(hasGiven ? 'ok' : 'loading');

  useEffect(() => {
    if (hasGiven) return undefined;
    let live = true;
    const load = async () => {
      for (let attempt = 0; attempt < 2; attempt += 1) {
        try {
          const response = await api.get('/api/public/offerings/', { skipErrorToast: true });
          if (live) {
            setList(Array.isArray(response?.data) ? response.data : []);
            setState('ok');
          }
          return;
        } catch (error) {
          if (attempt === 0) await new Promise((resolve) => window.setTimeout(resolve, RETRY_AFTER_MS));
        }
      }
      if (live) setState('failed');
    };
    load();
    return () => {
      live = false;
    };
  }, [hasGiven]);

  return hasGiven ? { offerings: given, state: 'ok' } : { offerings: list, state };
};

export default useSchoolOfferings;
